export default "__VITE_ASSET__Fa09TBAe__"